import React from "react";
import Button from "@mui/material/Button";
import { IButtonProperties } from "../ButtonParameters";

export interface fullWidthButtonProperties extends IButtonProperties {
  readonly fullWidth?: boolean;
  style?: React.CSSProperties;
}

const DEFAULT_PARAMENTERS: fullWidthButtonProperties = {
  fullWidth: true,
  onClick: () => {},
};

const FullWidthButton = (
  fullWidthButtonProperties: fullWidthButtonProperties
) => {
  let _parameters: any = {
    ...DEFAULT_PARAMENTERS,
    ...fullWidthButtonProperties,
  };

  return <Button {..._parameters} color={_parameters?.color || "default"}>{_parameters.text}</Button>;
};

export { FullWidthButton };
